import { render, staticRenderFns } from "./pt-challan-pdf.vue?vue&type=template&id=2c98aea2&"
import script from "./pt-challan-pdf.vue?vue&type=script&lang=js&"
export * from "./pt-challan-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports